import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

import { ISportEvent } from '@frontend/oxygen/shared-utils';
import { Observable, Subject, map, takeUntil, timer } from 'rxjs';

import { TimeSyncService } from '../../../core/services/timeSync/time-sync.service';
import { BASKET_BALL_SUPPORTED_PERIOD_CODES } from '../../../inPlay/constants/event-types.constant';
import { LiveEventClockProviderService } from './live-event-clock-provider.service';

@Component({
    selector: 'live-clock',
    templateUrl: 'live-clock.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, AsyncPipe],
})
export class LiveClockComponent implements OnDestroy {
    public liveTime: Observable<string> | null = null;
    public matchEtTime: string;
    @Output() public readonly clockUpdated: EventEmitter<null>;

    private _event: ISportEvent | null = null;
    private destroy$ = new Subject<void>();
    @Input() isBB: boolean;
    @Input() public set event(event: ISportEvent) {
        this._event = event;

        if (this.event && this.event.initClock && !this.event.clock) {
            const serverTimeDelta = this.timeSyncService.getTimeDelta();
            this.event.clock = this.liveEventClockProviderService.create(serverTimeDelta, this.event.initClock);
        }

        if (this.event && this.event.clock && !this.liveTime) {
            this.startTimer();
        }
    }

    public get event(): ISportEvent {
        return this._event!;
    }

    constructor(
        private timeSyncService: TimeSyncService,
        private liveEventClockProviderService: LiveEventClockProviderService,
    ) {
        this.clockUpdated = new EventEmitter();
    }

    private startTimer(): void {
        this.liveTime = timer(0, 1000).pipe(
            map((num: number) => {
                if (num > 0) {
                    this.event?.clock?.update();
                }
                this.matchEtTime = this.event.clock.matchEtTime;
                return {
                    liveTime: this.event.clock.liveTime,
                    matchTime: this.event.clock.matchTime,
                };
            }),
            map((val) => {
                this.clockUpdated.emit();
                if (this.matchEtTime) {
                    return val.liveTime !== null ? `${this.matchEtTime} ${val.liveTime}` : `${this.matchEtTime}`;
                }
                if (this.event.categoryId === '6' && val.liveTime) {
                    if (BASKET_BALL_SUPPORTED_PERIOD_CODES.includes(val.matchTime)) {
                        val.liveTime = '< ' + val.liveTime;
                    } else {
                        val.liveTime = null;
                    }
                }
                return val.liveTime;
            }),
            takeUntil(this.destroy$),
        );
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
